var imagep = document.getElementById('image_cropped_preview');
let uploadoriginalImageData = null;

/* canvas colour analysis — returns true if image contains non-black/white pixels */
function analyseCanvas(img) {
  var isFront = !!$(".front_tab.tab_items.active")[0];
  var canvas = document.getElementById(isFront ? 'imageCanvas' : 'imageCanvasback');
  var ctx = canvas.getContext('2d');
  canvas.width = img.width;
  canvas.height = img.height;
  ctx.drawImage(img, 0, 0);
  uploadoriginalImageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  var data = uploadoriginalImageData.data;
  var tolerance = 40;
  for (var i = 0; i < data.length; i += 4) {
    var r = data[i], g = data[i + 1], b = data[i + 2];
    if (r > tolerance && g > tolerance && b > tolerance) {
      // light pixel
    } else if (r > 255 - tolerance && g > 255 - tolerance && b > 255 - tolerance) {
      // near-white
    } else {
      return true;
    }
  }
  return false;
}

/* sets up the preview UI after a valid upload */
function setupUploadPreview(imageClass, cropClass, invcheck, invVal, src) {
  $(imageClass + ' .conva_imgs').css('display', 'block');
  $(invcheck).html(invVal);
  $('#preview_img').attr('src', src);
  $('#cropped_image').attr('src', src);
  $(cropClass).attr('src', src);
  $('.review_design_uploadimg').addClass('active');
  $('.input-options').addClass('hide');
  $('.back_upload').addClass('hide');
  $('#preview_img').css('display', 'block');
  $('#cropped_image').css('display', 'none');
  $('#some').removeAttr('style');
  $('.apply_btn').css('display', 'none');
  $('.undo_btn').css('display', 'none');
  $('.crop_img_btn').css('display', 'inline').removeAttr('disabled');
  $('.invert_btn').css('display', 'inline');
  $('.accept_btn').removeClass('hide');
  $('.cancle_btn').removeClass('hide');
  $('.preview_btn').addClass('hide');
  $('.clear_btn').addClass('hide');
  $(imageClass + ' .logo_img_gal').addClass('hide').attr('src', '');
  $(imageClass + ' .resizable').removeClass('hide');
}

/* resets canvas state and re-shows upload option */
function cancelUploadState(side) {
  var isFront = (side === 'front');
  var canvasId   = isFront ? '#imageCanvas'    : '#imageCanvasback';
  var uploadedId = isFront ? '#uploaded-image' : '#buploaded-image';
  var cropClass  = isFront ? '.front_crop'     : '.back_crop';
  var imageClass = isFront ? '.front_image'    : '.back_image';
  var urlClass   = isFront ? '.front_image_url': '.back_image_url';
  var checkbox   = isFront ? '#inverseCheckbox': '#backinverseCheckbox';
  $(canvasId).removeAttr('width').removeAttr('height');
  $(uploadedId).removeAttr('src');
  $(cropClass).removeAttr('src');
  $(urlClass).html('');
  $(imageClass).removeClass('both_textactive');
  $(checkbox).prop('checked', false).attr('disabled', 'disabled');
  $(imageClass + ' .conva_imgs').css('display', 'block');
}

/* on change upload */
$(document).on("change", ".fileinput", function(e) {
  var file = e.target.files[0];
  if (!file) { return; }

  var type = file.type;
  var type_reg = /^image\/(png)$/;
  if (!type_reg.test(type)) {
    $('.popup_alert').addClass('active');
    $('.content_1').html('This file type is unsupported.');
    return;
  }

  var reader = new FileReader();
  reader.onload = function(e) {
    var img = new Image();
    img.src = e.target.result;
    img.onload = function() {
      var w = this.width, h = this.height;
      if (w < 300 || h < 300) {
        $('.popup_alert').addClass('active');
        $('.content_1').html('The image is too small. Please upload an image that is a minimum of 300px in width and height, excluding whitespace.');
        return;
      }

      var isFront    = !!$(".front_tab.tab_items.active")[0];
      var side       = isFront ? 'front' : 'back';
      var imageClass = isFront ? '.front_image' : '.back_image';
      var cropClass  = isFront ? '.front_crop'  : '.back_crop';
      var invcheck   = isFront ? '.finvcheck'   : '.binvcheck';

      var containsColors = analyseCanvas(img);

      if (containsColors) {
        $('.images_popup .content_1').html('The image you have uploaded contains colors. Please make sure to upload a PNG image with no background color.');
        $('.images_popup').addClass('active');
        $(imageClass + ' .conva_imgs').css('display', 'none');

        $('.close_okimgs').on('click', function() {
          $(this).parents('.images_popup').removeClass('active');
          $('.cancle_btn').removeAttr('disabled');
          $('.accept_btn').removeAttr('disabled').html('<i class="fa fa-check"></i> <span>Accept</span>');
          setupUploadPreview(imageClass, cropClass, invcheck, '1', e.target.result);
        });

        $('.close_cancel').on('click', function() {
          $(this).parents('.images_popup').removeClass('active');
          $('.back_upload').removeClass('hide');
          $('#preview_img').removeAttr('src');
          $('#cropped_image').removeAttr('src');
          $('.cancle_btn').addClass('hide');
          $('.accept_btn').addClass('hide');
          $('.review_design_uploadimg').removeClass('active');
          $('.clear_btn').removeClass('hide');
          $('.preview_btn').removeClass('hide');
          $('.input-options').removeClass('hide');
          $('.fileinput').val('');
          cancelUploadState(side);
        });

      } else {
        $('.cancle_btn').removeAttr('disabled');
        $('.accept_btn').removeAttr('disabled').html('<i class="fa fa-check"></i> <span>Accept</span>');
        setupUploadPreview(imageClass, cropClass, invcheck, '0', e.target.result);
      }
    };
  };

  reader.readAsDataURL(file);
  $(".fileinput").val('');
});


$(document).on('click', '.close_ok', function() {
  $('.popup_alert').removeClass('active');
});

var cropper = '';

$(document).on('click', '#cropbutton', function() {
  $('#some').html('');
  var prevsrc = $('#preview_img').attr('src');
  $('#preview_img').css('display', 'none');
  $('#some').css('display', 'block');
  $('#cropbutton').css('display', 'none');
  $('.invert_btn').css('display', 'none');
  $('#apply_crop').css('display', 'inline');
  $('.undo_btn').css('display', 'inline');
  var img = document.createElement('img');
  img.id = 'image_cropped_preview';
  img.src = prevsrc;
  $('#some').html(img);
  cropper = new Cropper(img);
});

/* undo image */
$(document).on('click', '.undo_btn', function() {
  $('#cropbutton').removeAttr('disabled').css('display', 'inline');
  $('.invert_btn').css('display', 'inline');
  $('#apply_crop').css('display', 'none');
  $('.undo_btn').css('display', 'none');
  $('#preview_img').css('display', 'block');
  $('#cropped_image').css('display', 'none');
  $('#some').html('');
});

function b64toBlob(b64Data, contentType, sliceSize) {
  contentType = contentType || '';
  sliceSize = sliceSize || 512;
  var byteCharacters = atob(b64Data);
  var byteArrays = [];
  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);
    var byteNumbers = new Array(slice.length);
    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    byteArrays.push(new Uint8Array(byteNumbers));
  }
  return new Blob(byteArrays, { type: contentType });
}

/* apply crop button */
$(document).on('click', '#apply_crop', function() {
  var imgurl = cropper.getCroppedCanvas().toDataURL();
  var img = document.getElementById("cropped_image");
  img.src = imgurl;
  $('#cropped_image').css('display', 'block');
  $('#some').css('display', 'none');
  $(this).css('display', 'none');
  $('.crop_img_btn').css('display', 'inline').attr('disabled', 'disabled');
});


$(document).on('click', '.customize-item.upload_design', function() {
  $('.customize-selection').addClass('hide');
  $('.selected_design_box').addClass('active');
  $('.inner_selected_design.design_uplod.customization-section').addClass('active').removeAttr('style');
  $('.front_tab, .back_tab').removeClass('hide');
  $('.edit_front_tab, .edit_back_tab').addClass('hide');
  $('.color_customize_variants').removeAttr('style');
  $('.upload_nav_design .clear_btn, .upload_nav_design .preview_btn').removeClass('hide');
  $('.addtocart_box').addClass('hide');

  var front_text = $('.front_image .cstm_textup').html();
  var back_text = $('.back_image .cstm_textup').html();
  var front_image_url = $('.front_image_url').html();
  var back_image_url = $('.back_image_url').html();
  var front_inverse = $('.front_image_invert').html();
  var back_inverse = $('.back_image_invert').html();

  document.getElementById("inverseCheckbox").checked = (front_image_url != '' && front_inverse == "Yes");
  document.getElementById("backinverseCheckbox").checked = (back_image_url != '' && back_inverse == "Yes");

  if (front_text != '' && front_text != ' ') {
    $('.front_image .text_uploaded').removeClass('hide').addClass('active');
  }
  if (back_text != '' && back_text != ' ') {
    $('.back_image .text_uploaded').removeClass('hide').addClass('active');
  }
});


$(document).on('click', '.cancle_btn', function() {
  $('.back_upload').removeClass('hide');
  $('#preview_img').removeAttr('src');
  $('#cropped_image').removeAttr('src');
  $('.cancle_btn').addClass('hide');
  $('.accept_btn').addClass('hide');
  $('.review_design_uploadimg').removeClass('active');
  $('.clear_btn').removeClass('hide');
  $('.preview_btn').removeClass('hide');
  $('.input-options').removeClass('hide');
  $('.fileinput').val('');

  if ($(".front_image.active")[0]) {
    $('.gallery_name_front').html('');
    cancelUploadState('front');
  }
  if ($(".back_image.active")[0]) {
    $('.gallery_name_back').html('');
    cancelUploadState('back');
  }
});


$(document).on('click', '.invert_btn', function() {
  if ($(".front_tab.tab_items.active")[0]) {
    $('.front_image .resizable').toggleClass('invert');
    $('#preview_img').toggleClass('invert');
  }
  if ($(".back_tab.tab_items.active")[0]) {
    $('.back_image .resizable').toggleClass('invert');
    $('#preview_img').toggleClass('invert');
  }
});

/* back upload */
$(document).on('click', '.back_upload', function() {
  $('.customize-selection').removeClass('hide');
  $('.selected_design_box').removeClass('active');
  $('.inner_selected_design.design_uplod.customization-section').removeClass('active');
});
